<template>
  <div class="about">
    <div v-if="!pc" class="m">
      <aboutM :lang="lang"></aboutM>
    </div>
    <div v-else class="pc">
      <about></about>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    aboutM: () => import("@/components/about_m"),
    about: () => import("@/components/about")
  },
  props: ['pc']
}
</script>

<style lang="scss" scoped>
</style>
